<template>
  <section class="container" :class="{ 'android-context': isAndroidContext }">
    <div class="card-container">
      <div id="payu-card-number" class="payu-card-form font-size-big"></div>

      <div class="card-details clearfix">
        <div class="expiration">
          <div id="payu-card-date" class="payu-card-form font-size-big"></div>
        </div>

        <div class="cvv">
          <div id="payu-card-cvv" class="payu-card-form font-size-big"></div>
        </div>
      </div>
    </div>
    <button id="tokenizeButton" class="font-size-middle">ZAREJESTRUJ KARTĘ</button>
    <div id="responseTokenize" class="font-size-middle"></div>
  </section>
</template>

<script>
import { getPaymentService } from '@/services/paymentService'
import { getAndroidContext } from '@/services/sessionProps'
import { PAYU, ADDRESSES } from '@/variables'

export default {
  name: 'CardDetailsForm',
  data() {
    return {
      isAndroidContext: false
    }
  },
  mounted () {
    this.isAndroidContext = getAndroidContext().isAndroidContext()

    let payuSecureFormScriptElement = document.createElement('script')
    payuSecureFormScriptElement.setAttribute('src', ADDRESSES.PAYU_SECURE_FORM)

    payuSecureFormScriptElement.onload = () => {
      const optionsForms = {
        cardIcon: true,
        style: {
          basic: {
            fontSize: '20px',
            fontColor: '#ffffff',
          }
        },
        placeholder: {
          number: 'Numer Karty',
          date: 'MM/YY',
          cvv: 'CVV'
        },
        lang: 'pl'
      }

      let renderError = function (element, errors) {
        element.className = 'response-error'
        let messages = []
        errors.forEach(function (error) {
          messages.push(error.message)
        })
        element.innerText = messages.join(', ')
      }

      let renderSuccess = async (element, msg) => {
        element.className = 'response-success'
        const startTimer = true
        this.$emit('success', startTimer)

        try {
          const checkSubscriptionPlans = await getPaymentService().checkRecurringSubscriptionPlans()

          if (checkSubscriptionPlans.length === 0) {
            await getPaymentService().createRecurringSubscriptionPlans()
          }

          await getPaymentService().createPayuCard(msg)
          const id = await getPaymentService().createFirstTransaction()
          const returnUrl = await getPaymentService().getRecurringPayuPaymentUrl(id)

          this.$emit('proceedReturnUrl', returnUrl || null)
        } catch(err) {
          this.$emit('addCardError')
        }
      }

//inicjalizacja SDK poprzez podanie POS ID oraz utworzenie obiektu secureForms
      const payuSdkForms = PayU(PAYU.POS_ID)
      const secureForms = payuSdkForms.secureForms()

//utworzenie formularzy podając ich typ oraz opcje
      const cardNumber = secureForms.add('number', optionsForms)
      const cardDate = secureForms.add('date', optionsForms)
      const cardCvv = secureForms.add('cvv', optionsForms)

//renderowanie formularzy
      cardNumber.render('#payu-card-number')
      cardDate.render('#payu-card-date')
      cardCvv.render('#payu-card-cvv')

      const tokenizeButton = document.getElementById('tokenizeButton')
      const responseElement = document.getElementById('responseTokenize')

      tokenizeButton.addEventListener('click', function () {
        responseElement.innerText = ''

        try {
          //tokenizacja karty (komunikacja z serwerem PayU)
          payuSdkForms.tokenize('MULTI').then(function (result) {
            result.status === 'SUCCESS'
                ? renderSuccess(responseElement, result.body.token)
                //tutaj wstaw przekazanie tokena do back-endu
                : renderError(responseElement, result.error.messages)
            //sprawdź typ błędu oraz komunikaty i wyświetl odpowiednią informację użytkownikowi
          })
        } catch (e) {
          console.log(e) // błędy techniczne
        }
      })
    }

    document.head.appendChild(payuSecureFormScriptElement)
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.container * {
  font-family: "Roboto", Helvetica, sans-serif;
}


.container {
  text-align: center;
  width: 420px;
  display: block;
  box-sizing: border-box;
  max-width: 100%;
  &.android-context {
    width: 420px!important;
  }
}

.card-container {
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  text-align: left;
  box-sizing: border-box;
  color: $dark-text;
}

.card-container aside {
  padding-bottom: 6px;
}

.payu-card-form {
  padding: 5px;
  border-bottom: 1px solid $dark-text;
}

.card-details {
  clear: both;
  overflow: auto;
  margin-top: 30px;
}

.card-details .expiration {
  width: 50%;
  float: left;
  padding-right: 5%;
}

.card-details .cvv {
  width: 50%;
  float: left;
}

button {
  font-family: "Roboto", sans-serif;
  background-color: black;
  border: 2px solid $primary;
  padding: 8px 15px;
  margin: 10px auto;
  cursor: pointer;
  color: $primary;
  min-width: 200px;
  min-height: 45px;
  border-radius: 5px;
  font-weight: bold;
}

.response-success {
  color: #438F29;
}

.response-error {
  color: #990000;
}

.man-acc {
  text-decoration: none;
  color: #d6ae5d;
}

@media only screen and (max-width: 500px) {
  .container {
    width: 300px;
  }
}
</style>
